import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Session } from '../../services/session/session.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
      private router: Router,
      private session: Session
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.session.currentUser) {
            // logged in so return true

            return true;
        }

        if(sessionStorage.getItem('id_token') && sessionStorage.getItem('access_token') && sessionStorage.getItem('currentUser')){
            this.session.setIdToken(sessionStorage.getItem('id_token'));
            this.session.setAccessToken(sessionStorage.getItem('access_token'));
            this.session.setCurrentUser(JSON.parse(sessionStorage.getItem('currentUser')));
            return true;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/pages/login']);
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/guards/auth/auth.guard.ts